import { colors } from '@/styles/color';
import { heights } from '@/styles/heights';
import { fontSize, fontWeight } from '@/styles/font';
import * as scale from '@/styles/scale';
import { Theme } from '@emotion/react';

const theme: Theme = {
	fontSize,
	fontWeight,
	colors,
	scale,
	heights,
};
export default theme;
